import React, {useState} from 'react';
import SideNavigationBar from "src/components/SideNavigationBar";
import { Routes, Route } from "react-router-dom";
import AppLayout from "@cloudscape-design/components/app-layout";
import {ROUTES} from "src/constants";
import APIOnboardingForm from "src/components/APIOnboardingForm";


const App = () => {
    const [navigationOpen, setNavigationOpen] = useState(true);

    const handleMainNavigationChange = ({ detail }: { detail: { open: boolean } }) => {
        setNavigationOpen(detail.open);
    };

    return (
            <AppLayout
                navigationOpen={navigationOpen}
                onNavigationChange={handleMainNavigationChange}
                navigation={<SideNavigationBar/>}
                toolsHide
                contentType="table"
                content={
                    <div style={{ height: "100%" }}>
                        <Routes>
                            <Route path={ROUTES.API_ONBOARDING} element={<APIOnboardingForm />} />
                        </Routes>
                    </div>
                }
            />
    );
};

export default App;
